/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, Button, styled, useTheme } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { FC } from "react";

interface Props {
  disabled?: boolean;
  onClick?: () => void;
}

export const PointSwapper: FC<Props> = ({ disabled, onClick }: Props) => {
  const theme = useTheme();
  return (
    <Container>
      <VerticalLine
        sx={{ borderColor: disabled ? theme.palette.grey[400] : "black" }}
      />
      {/* <ButtonContainer> */}
      <Button
        onClick={onClick}
        disabled={disabled}
        variant="outlined"
        color="inherit"
        sx={{
          padding: "5px",
          minWidth: "auto",
        }}
        size="large"
      >
        <SwapVertIcon fontSize="large" />
      </Button>
      {/* </ButtonContainer> */}
      <VerticalLine
        sx={{ borderColor: disabled ? theme.palette.grey[400] : "black" }}
      />
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "fit-content",
  height: "85px",
}));

const VerticalLine = styled(Box)(({ theme }) => ({
  width: "0px",
  height: "100%",
  borderLeft: "1px solid black",
  borderRight: "1px solid black",
  flexGrow: 1,
}));
